import React from 'react';
import PropTypes from 'prop-types';
import { Table, IconButton, Icon } from 'rsuite';
import { InventoryAvailabilityType } from '../../../../interfaces/inventory';

const { Cell } = Table;

const DeleteCell = ({ dataKey, rowData, onClick, isDeleting, ...props }) => (
  <Cell {...props}>
    <IconButton
      color="red"
      appearance="link"
      style={{ top: '-8px', paddingLeft: 18 }}
      icon={<Icon icon="trash" style={{ width: 32 }} />}
      onClick={() => onClick(rowData)}
      disabled={isDeleting(rowData) || rowData.quantity > 0}
    />
  </Cell>
);

DeleteCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: InventoryAvailabilityType,
  onClick: PropTypes.func,
  isDeleting: PropTypes.func
};

DeleteCell.defaultProps = {
  rowData: null,
  onClick: null,
  isDeleting: () => {}
};

export default DeleteCell;
